/**
 * 与 iOS TeachingWeekPattern 保持一致：无法识别的旧格式按全学期处理，
 * 避免同步到 Web 后课程静默从课表消失。
 */
export function parseTeachingWeeks(rawValue: string, totalWeeks: number) {
  const all = new Set(Array.from({ length: Math.max(0, totalWeeks) }, (_, index) => index + 1));
  const raw = rawValue.trim();
  if (!raw) return all;
  const containsBothParity = raw.includes('单双');
  const oddOnly = !containsBothParity && /单周|[（(]单[）)]/.test(raw);
  const evenOnly = !containsBothParity && /双周|[（(]双[）)]/.test(raw);
  const weeks = new Set<number>();
  for (const match of raw.matchAll(/(\d+)\s*[-~至—–]\s*(\d+)/g)) {
    const start = Number(match[1]);
    const end = Number(match[2]);
    for (let week = Math.min(start, end); week <= Math.max(start, end); week += 1) {
      if (week >= 1 && week <= totalWeeks) weeks.add(week);
    }
  }
  for (const match of raw.matchAll(/\d+/g)) {
    const week = Number(match[0]);
    if (week >= 1 && week <= totalWeeks) weeks.add(week);
  }
  const source = weeks.size ? weeks : all;
  return new Set([...source].filter(week => oddOnly ? week % 2 === 1 : evenOnly ? week % 2 === 0 : true));
}

export function formatTeachingWeeks(weeks: Set<number>, totalWeeks: number) {
  const normalized = [...weeks]
    .filter(week => week >= 1 && week <= totalWeeks)
    .sort((left, right) => left - right);
  if (!normalized.length) return '未选择';
  const all = Array.from({ length: totalWeeks }, (_, index) => index + 1);
  if (sameWeeks(normalized, all)) return `1–${totalWeeks}周`;
  const odds = all.filter(week => week % 2 === 1);
  if (sameWeeks(normalized, odds)) return '单周';
  const evens = all.filter(week => week % 2 === 0);
  if (sameWeeks(normalized, evens)) return '双周';

  const segments: string[] = [];
  let start = normalized[0]!;
  let previous = normalized[0]!;
  for (const week of normalized.slice(1)) {
    if (week === previous + 1) {
      previous = week;
      continue;
    }
    segments.push(start === previous ? `${start}` : `${start}–${previous}`);
    start = week;
    previous = week;
  }
  segments.push(start === previous ? `${start}` : `${start}–${previous}`);
  return `${segments.join('、')}周`;
}

function sameWeeks(left: number[], right: number[]) {
  return left.length === right.length && left.every((week, index) => week === right[index]);
}
